<template>
  <div>
    <div class="loading-spinner-outer" v-if="saving">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Saving, please wait
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box-content">
        <template v-if="!loading && notes.length !== 0">
          <div class="enquiry-messages">
            <div class="enquiry-message" v-for="note in notes">
              <div class="enquiry-message-header">
                <div class="from">
                  <template v-if="logged_in_user.id == note.user_id">
                    Created by: <span class="txt-secondary">You</span>
                  </template>
                  <template v-else>
                    Created by: {{ note.user.name }}
                  </template>
                </div>
                <div class="date">
                  {{ note.friendly_created_at }}
                </div>
              </div>
              <div class="enquiry-message-content" v-html="note.message"></div>
            </div>
          </div>
          <div class="pagination-bar wrapper mb-3 mt-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else>
          There are no notes to show.
        </div>
        <hr>
        <div class="form-group">
          <label>Add a note</label>
          <textarea rows="5" v-model="new_note" class="form-control" style="height: 175px;"></textarea>
        </div>
        <div class="align-right">
          <a class="btn-primary" @click.prevent="saveNote()">
            Add Note
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'company',
    'logged_in_user',
  ],
  mounted() {
    this.loadNotes();
  },
  data() {
    return {
      new_note: '',
      notes: [],
      saving: false,
      current_page: 1,
      total_count: 0,
      total_pages: 0,
      limit: 5,
      loading: true,
    }
  },
  methods: {
    loadNotes: _.debounce(function () {
      this.loading = true;
      axios.post('/company/loadNotes', {
        company_id: this.company.id,
        page_number: this.current_page,
        limit: this.limit,
      }).then((response) => {
        this.notes = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
      });
    }, 250),
    saveNote(){
      this.saving = true;
      const validationErrors = Validate({
        note: this.new_note,
      }, {
        note: {
          presence: {
            allowEmpty: false,
          },
        },
      });

      if (validationErrors) {
        Swal.fire({
          title: 'Unable to save note',
          icon: 'error',
          html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
        });
        this.saving = false;
        return;
      }

      axios.post('/company/create-note', {
        message: this.new_note,
        company_id: this.company.id,
        user_id: this.logged_in_user.id,
      }).then((response) => {
        this.new_note = '';
        this.saving = false;
        this.loadNotes();
      });
    },
    prevPage() {
      this.current_page = this.current_page - 1;
      this.loadNotes();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.loadNotes();
    },
  },
};
</script>
